module.exports = new __parcel__URL__("special.22b11ec1.png").toString();